export const DOCUMENT = 'DOCUMENT';
export const VIDEO = 'VIDEO';
export const AUDIO = 'AUDIO';
export const DEFAULT = 'DEFAULT';